function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import React from 'react';
import { Button } from '@applyboard/ui-components';
import { CheckboxGroup, Flex } from '@applyboard/crystal-ui';
export function FileCategoriesField(props) {
  useSelectAllIfStar(props);
  var value = Array.isArray(props.value) ? props.value : [];
  var _splitArrayInHalf = splitArrayInHalf(props.options),
    _splitArrayInHalf2 = _slicedToArray(_splitArrayInHalf, 2),
    firstColumn = _splitArrayInHalf2[0],
    secondColumn = _splitArrayInHalf2[1];
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(CheckboxGroup, {
    helpText: props.helperText,
    invalid: props.error,
    label: "File Types",
    onChange: props.onChange,
    required: props.required,
    value: value
  }, /*#__PURE__*/React.createElement(Flex, {
    direction: {
      xs: 'column',
      sm: 'row'
    },
    gap: {
      xs: 0,
      sm: 24
    }
  }, /*#__PURE__*/React.createElement(Flex, {
    direction: "column"
  }, firstColumn.map(function (fileCategory, idx) {
    return /*#__PURE__*/React.createElement(CheckboxGroup.Option, {
      key: idx,
      label: fileCategory.label,
      value: fileCategory.value,
      disabled: props.plagiarismCheckEnabled && !fileCategory.supportsPlagiarismCheck
    });
  })), /*#__PURE__*/React.createElement(Flex, {
    direction: "column"
  }, secondColumn.map(function (fileCategory, idx) {
    return /*#__PURE__*/React.createElement(CheckboxGroup.Option, {
      key: idx,
      label: fileCategory.label,
      value: fileCategory.value,
      disabled: props.plagiarismCheckEnabled && !fileCategory.supportsPlagiarismCheck
    });
  })))), /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    onClick: function onClick() {
      props.onChange([]);
    },
    ml: -1.5
  }, "Deselect All"));
}

/**
 * If props.value is '*' then this effect will convert that to an array of all
 * file types and call onChange with this new value
 *
 * @param props
 */
function useSelectAllIfStar(props) {
  React.useEffect(function () {
    if (props.value === '*' && props.options.length > 0) {
      var _newValue = props.options.map(function (fileCategoryOption) {
        return fileCategoryOption.value;
      });
      props.onChange(_newValue);
    }
  }, [props.options, props.onChange, props.value]);
}
function splitArrayInHalf(arr) {
  var middleIndex = Math.ceil(arr.length / 2);
  var firstHalf = arr.slice(0, middleIndex);
  var secondHalf = arr.slice(middleIndex);
  return [firstHalf, secondHalf];
}